export default __webpack_public_path__ + "static/media/kausi12-min.dab39233.jpg";